import * as z from 'zod';

import { commissionPlansQueryLinkerSchema } from '@/_pages/settings/commission-plans/shared';
import { booleanQuerySchema, currencyInput } from '@/_schemas/generic';
import { teamMemberQueryLinkerWithContactInfoSchema } from '@/_schemas/team-members/team-members-query-linker-with-contact-info-schema';

export const commissionsQuerySchema = z.object({
  id: z.number(),
  agreement_id: z.number(),
  team_member_id: z.number(),
  team_member: teamMemberQueryLinkerWithContactInfoSchema.nullable(),

  one_time_paid: booleanQuerySchema(),
  recurring_paid: booleanQuerySchema(),

  one_time_paid_date: z.string().nullable(),
  recurring_paid_date: z.string().nullable(),

  commission_plan_id: z.number().nullable(),
  commission_plan: commissionPlansQueryLinkerSchema.nullable(),

  one_time_paid_amount: currencyInput.querySchema(),
  recurring_paid_amount: currencyInput.querySchema(),
});

export type CommissionsQuerySchema = z.infer<typeof commissionsQuerySchema>;

export const commissionsFormSchemaRaw = commissionsQuerySchema
  .omit({
    team_member_id: true,
    commission_plan_id: true,
  })
  .extend({
    one_time_paid_amount: currencyInput.formSchema(),
    recurring_paid_amount: currencyInput.formSchema(),
  });

export const commissionsFormSchema = commissionsFormSchemaRaw
  .refine(
    ({ one_time_paid, one_time_paid_date, one_time_paid_amount }) => {
      if (one_time_paid) {
        return !!one_time_paid_date && !!one_time_paid_amount;
      }
      return true;
    },
    {
      error: 'Amount and Date are required',
      path: ['one_time_paid'],
    }
  )
  .refine(
    ({ recurring_paid, recurring_paid_date, recurring_paid_amount }) => {
      if (recurring_paid) {
        return !!recurring_paid_date && !!recurring_paid_amount;
      }
      return true;
    },
    {
      error: 'Amount and Date are required',
      path: ['recurring_paid'],
    }
  );

export type CommissionsFormSchema = z.infer<typeof commissionsFormSchema>;

export const commissionsMutationSchema = commissionsFormSchemaRaw
  .omit({
    team_member: true,
    commission_plan: true,
  })
  .extend({
    team_member_id: z.number(),
    // BE setting this automatically based on team_member_id
    // commission_plan_id: z.number().nullable(),
    one_time_paid_amount: currencyInput.querySchema(),
    recurring_paid_amount: currencyInput.querySchema(),
  });

export type CommissionsMutationSchema = z.infer<typeof commissionsMutationSchema>;

export const commissionsCreateSchema = commissionsMutationSchema.omit({
  id: true,
});

export type CommissionsCreateSchema = z.infer<typeof commissionsCreateSchema>;
